var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GmapMap',{ref:"mapRef",staticStyle:{"height":"360px","margin":"32px auto"},attrs:{"center":_vm.myCoordinates31_33,"zoom":_vm.zoom}},[_c('GmapMarker',{attrs:{"position":_vm.myCoordinates21}}),_c('GmapMarker',{attrs:{"position":_vm.myCoordinates31_33}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }